<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>Copy Agent</template>
    <v-row>
      <v-col class="pb-0"
        ><v-text-field
          v-model="newName"
          label="New Name"
          :outlined="outlinedInputs"
        ></v-text-field
      ></v-col>
      <v-col class="pb-0"
        ><v-text-field
          v-model="newCompanyCode"
          label="New Company Code"
          :outlined="outlinedInputs"
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-container class="py-0">
          <v-row align="baseline">
            <v-col sm="4" class="py-0">
              <v-switch
                v-model="configSettings"
                label="Config Settings"
              ></v-switch>
            </v-col>
            <v-col sm="4" class="py-0">
              <v-switch
                v-model="financeSettings"
                label="Finance Settings"
              ></v-switch>
            </v-col>
            <v-col sm="4" class="py-0">
              <v-switch v-model="agentGroups" label="Agent Groups"></v-switch>
            </v-col>
            <v-col sm="4" class="py-0">
              <v-switch v-model="paymentTerms" label="Payment Terms"></v-switch>
            </v-col>
            <v-col sm="4" class="py-0">
              <v-switch v-model="customFields" label="Custom Fields"></v-switch>
            </v-col>
            <v-col sm="4" class="py-0">
              <v-switch v-model="staff" label="Staff"></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid || inProgress" @click="onSave">{{inProgress ? 'Please wait...' : 'Copy'}}</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../shared/BasicDialog";
const CLONE_AGENT = gql`
  mutation cloneAgent($input: CloneAgentInput!) {
    cloneAgent(input: $input) {
      id
      name
    }
  }
`;
export default {
  name: "clone-agent",

  props: {
    show: {
      type: Boolean,
      default: () => true,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
  },

  data() {
    //console.log("this.value",this.value)
    return {
      inProgress: false,
      newName: this.value ? `${this.value.name} Copy` : "New Name",
      newCompanyCode: this.value ? `${this.value.companyCode} Copy` : "New Company Code",
      agentGroups: true,
      configSettings: true,
      financeSettings: true,
      paymentTerms: true,
      customFields: true,
      staff: false,
    };
  },

  computed: {
    isValid() {
      return this.newName != "" && this.value && this.value.id != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.newName = `${newVal.name} Copy`;
      this.newCompanyCode = newVal.companyCode && newVal.companyCode != '' ? `${newVal.companyCode} Copy` : "New Company Code";
    },
  },

  methods: {
    onSave() {
      const input = {
        id: this.value.id,
        newName: this.newName,
        newCompanyCode: this.newCompanyCode,
        agentGroups: this.agentGroups,
        configSettings: this.configSettings,
        financeSettings: this.financeSettings,
        financeSettings: this.financeSettings,
        paymentTerms: this.paymentTerms,
        customFields: this.customFields,
        staff: this.staff,
      };
      this.cloneAgent(input);
    },
    async cloneAgent(input) {
      this.inProgress = true;
      try {
        const result = await this.$apollo.mutate({
          mutation: CLONE_AGENT,
          variables: { input },
        });
        //console.log(result);
        if (result.data.cloneAgent.id) {
          this.$emit("complete", { ...result.data.cloneAgent });
        }
        inProgress = false;
      } catch (error) {
        this.inProgress = false;
        console.log(error);
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/agents/CloneAgent.vue